
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyA1hv_J7QLwtx9iJxCPndmFOewl8kCyIf0",
  authDomain: "chat-4a5de.firebaseapp.com",
  projectId: "chat-4a5de",
  storageBucket: "chat-4a5de.appspot.com",
  messagingSenderId: "171727521676",
  appId: "1:171727521676:web:aa553dbeb7e43ed4d678a9"
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth();
export const storage=getStorage();
export const db=getFirestore(app)